import { useState, useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { usePortfolioData } from '../../../contexts/PortfolioDataContext';
import { supabase } from '../../../lib/supabase';

/**
 * useUserData - Provides current user information and profile data
 * Integrates authentication and portfolio contexts
 */
export const useUserData = () => {
  const { user, isAuthenticated } = useAuth();
  const { userProfile, loading, error } = usePortfolioData();
  const [displayName, setDisplayName] = useState('');

  useEffect(() => {
    const loadDisplayName = async () => {
      if (!user?.id) return;
      
      try {
        const { data: personalInfo } = await supabase
          .from('personal_info')
          .select('first_name, last_name')
          .eq('user_id', user.id)
          .single();

        const fullName = [personalInfo?.first_name, personalInfo?.last_name]
          .filter(Boolean)
          .join(' ')
          .trim();

        setDisplayName(fullName || user?.email?.split('@')?.[0] || 'Student');
      } catch (err) {
        console.warn('Display name fallback due to profile fetch error', err?.message);
        setDisplayName(user?.email?.split('@')?.[0] || 'Student');
      }
    };
    
    loadDisplayName();
  }, [user?.id]);

  return {
    user,
    userProfile,
    isAuthenticated,
    loading,
    error,
    fullName: displayName || user?.email?.split('@')[0] || 'Student',
    email: user?.email,
  };
};

export default useUserData;
